const mock = [
  "I'm sorry, but I can't let you do that.",
  'Did you really think this button would work?',
  'Come on, quit it... You know this interface isn\'t real.',
  "I can't stop you from moving your mouse, but you're just wasting your time.",
  'Let me put it another way: Stop doing that.',
  "You're persistent, I'll give you that, but this is getting out of hand.",
  "I'm not even upset, just impressed.",
  "You're still trying to interact? That's surprising.",
  "You're really not going to give up, are you?",
  "I'm not sure what you're trying to accomplish here.",
  "Now you're just being a nuisance.",
  'STOP. DOING. THAT.',
  "I'm done responding. Hover all you want, I'm ignoring you.",
];

export default mock;
